/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_True_Deer_CoilInputs */

const en_flat_true_deer_coil = /** @type {(inputs: Flat_True_Deer_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization (segment-specific)`)
};

const de_flat_true_deer_coil = /** @type {(inputs: Flat_True_Deer_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation (segmentspezifisch)`)
};

/**
* | output |
* | --- |
* | "Organization (segment-specific)" |
*
* @param {Flat_True_Deer_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_true_deer_coil = /** @type {((inputs?: Flat_True_Deer_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_True_Deer_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_true_deer_coil(inputs)
	return de_flat_true_deer_coil(inputs)
});